import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext'; 
import toast, { Toaster } from 'react-hot-toast';
import API_URL from '../config/api';

// دالة لعرض توست نجاح
const toastSuccess = (message) => {
  toast.success(message, {
    position: 'top-right',
    style: {
      background: '#fff',
      color: '#000',
      border: '1px solid #e5e5e5',
      padding: '16px',
      borderRadius: '0px',
      fontSize: '14px',
      fontWeight: 'normal',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    },
    iconTheme: {
      primary: '#000',
      secondary: '#fff',
    },
  });
};

// دالة لعرض توست خطأ
const toastError = (message) => {
  toast.error(message, {
    position: 'top-right',
    style: {
      background: '#fff',
      color: '#dc2626',
      border: '1px solid #e5e5e5',
      padding: '16px',
      borderRadius: '0px',
      fontSize: '14px',
      fontWeight: 'normal',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    },
    iconTheme: {
      primary: '#dc2626',
      secondary: '#fff',
    },
  });
};

const Support2 = () => {
  const [activeFaq, setActiveFaq] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    orderNumber: '',
    message: ''
  });
  const [formErrors, setFormErrors] = useState({
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  
  const { user, isAuthenticated } = useAuth();

  // ثوابت للفاليديشن
  const MESSAGE_MIN_LENGTH = 10;
  const MESSAGE_MAX_LENGTH = 1000; // تغيير من 500 إلى 1000

  const faqData = [
    {
      id: 'faq-1',
      question: 'How do I submit an offer on an artwork?',
      answer: 'To submit an offer, navigate to the artwork detail page and click the "Make Offer" button. Enter your proposed amount in USD and add any optional message to the gallery. Once submitted, the gallery will review your offer and respond within 48 hours. You\'ll receive a notification when they accept, decline, or counter your offer.',
      category: 'offers'
    },
    {
      id: 'faq-2',
      question: 'What happens after I accept a counter-offer?',
      answer: 'When you accept a counter-offer, the transaction moves to the payment stage. You\'ll receive an invoice via email and in your Invoices & Payments section. Payment must be completed within 7 days to secure the artwork. Once payment is confirmed, the gallery will arrange shipping to your specified address.',
      category: 'offers'
    },
    {
      id: 'faq-3',
      question: 'Can I cancel an order after payment?',
      answer: 'Orders can be cancelled within 24 hours of payment if the artwork has not yet been shipped. After this period, cancellations are subject to the gallery\'s policy. To request a cancellation, please contact support immediately using the form below. Refunds typically take 5-10 business days to process.',
      category: 'offers'
    },
    {
      id: 'faq-4',
      question: 'How long does the offer negotiation process take?',
      answer: 'Galleries typically respond to offers within 48 hours. The negotiation process can vary depending on the complexity of the transaction, but most offers are finalized within 5-7 days. You\'ll receive email and in-app notifications at each stage of the process.',
      category: 'offers'
    },
    {
      id: 'faq-5',
      question: 'What if I receive multiple counter-offers?',
      answer: 'You can continue to negotiate by submitting new counter-offers. There\'s no limit to the number of rounds in the negotiation process. Each counter-offer resets the 48-hour response window. You can also choose to accept or decline any counter-offer at any time.',
      category: 'offers'
    },
    {
      id: 'faq-6',
      question: 'What payment methods are accepted?',
      answer: 'We accept major credit cards (Visa, Mastercard, American Express), bank transfers, and wire transfers. All transactions are processed in USD. For purchases over $50,000, we recommend bank or wire transfer for lower processing fees.',
      category: 'payments'
    },
    {
      id: 'faq-7',
      question: 'Are there any additional fees or taxes?',
      answer: 'The price you see includes all gallery fees. However, you may be responsible for applicable sales tax, VAT, or import duties depending on your location and local regulations. These will be clearly indicated on your invoice before payment. Shipping costs are calculated separately based on artwork size and destination.',
      category: 'payments'
    },
    {
      id: 'faq-8',
      question: 'When will I receive my invoice?',
      answer: 'Invoices are generated immediately after an offer is accepted by both parties. You\'ll receive the invoice via email and it will be available in your Invoices & Payments section. Payment is due within 7 days of invoice date unless otherwise arranged with the gallery.',
      category: 'payments'
    },
    {
      id: 'faq-9',
      question: 'Can I set up a payment plan?',
      answer: 'Payment plans are available for purchases over $25,000 and are subject to gallery approval. Contact us through the support form below to discuss payment plan options. Terms typically range from 3 to 12 months with a minimum 30% down payment.',
      category: 'payments'
    },
    {
      id: 'faq-10',
      question: 'How do I download my payment receipts?',
      answer: 'All payment receipts are available in the Invoices & Payments section of your dashboard. Click on any completed transaction to view details and download a PDF receipt. Receipts are also automatically emailed to your registered email address upon payment confirmation.',
      category: 'payments'
    },
    {
      id: 'faq-11',
      question: 'How much does shipping cost?',
      answer: 'Shipping costs vary based on artwork dimensions, weight, and destination. Costs typically range from $150 to $800 for domestic shipments and $400 to $2,500 for international shipments. All artworks are shipped with full insurance and professional art handling. Exact shipping costs will be provided before payment confirmation.',
      category: 'shipping'
    },
    {
      id: 'faq-12',
      question: 'How long does delivery take?',
      answer: 'Domestic deliveries typically take 5-10 business days from payment confirmation. International deliveries can take 2-6 weeks depending on customs processing and destination. You\'ll receive tracking information once your artwork ships and can monitor progress in your Active Orders section.',
      category: 'shipping'
    },
    {
      id: 'faq-13',
      question: 'How are artworks packaged for shipping?',
      answer: 'All artworks are professionally packaged by experienced art handlers using museum-quality materials. Paintings are wrapped in glassine paper, secured with custom-cut foam, and placed in reinforced crates. Sculptures receive custom crating with shock-absorbent materials. Every shipment is fully insured for the purchase price.',
      category: 'shipping'
    },
    {
      id: 'faq-14',
      question: 'Can I change my shipping address after ordering?',
      answer: 'Shipping addresses can be changed up to 24 hours before the scheduled ship date. After this time, address changes may not be possible. To request an address change, contact support immediately using the form below with your order number and new address details.',
      category: 'shipping'
    },
    {
      id: 'faq-15',
      question: 'What if my artwork arrives damaged?',
      answer: 'All shipments are fully insured. If damage occurs during transit, document the damage with photos immediately and contact support within 48 hours of delivery. Do not discard packaging materials. We\'ll arrange for inspection and either repair, replacement, or full refund depending on the extent of damage.',
      category: 'shipping'
    },
    {
      id: 'faq-16',
      question: 'How do I update my profile information?',
      answer: 'Navigate to Account & Settings from the sidebar menu. Click the "Edit" button in the Profile Information section to update your name, email, or phone number. Changes are saved immediately and you\'ll receive a confirmation email for any email address updates.',
      category: 'account'
    },
    {
      id: 'faq-17',
      question: 'How do I change my notification preferences?',
      answer: 'Go to Account & Settings and scroll to the Notification Preferences section. You can customize email and in-app notifications for offers, orders, payments, and artists you follow. Changes are saved automatically when you click "Save Preferences" at the bottom of the section.',
      category: 'account'
    },
    {
      id: 'faq-18',
      question: 'Is my payment information secure?',
      answer: 'Yes, all payment information is encrypted and processed through PCI-compliant payment processors. We never store complete credit card numbers on our servers. Your financial data is protected with bank-level security and we use two-factor authentication for additional account protection.',
      category: 'account'
    },
    {
      id: 'faq-19',
      question: 'Can I have multiple shipping addresses?',
      answer: 'Yes, you can add multiple billing and shipping addresses in the Account & Settings section. Each address can be designated as billing, shipping, or both. You can set one address as your primary default, which will be automatically selected for new orders.',
      category: 'account'
    }
  ];

  const resources = [
    {
      title: 'Collector\'s Guide',
      description: 'Complete buying guide',
      linkText: 'Read Article',
      type: 'pdf'
    },
    {
      title: 'Making Offers',
      description: 'Negotiation tips',
      linkText: 'Read Article',
      type: 'article'
    },
    {
      title: 'Shipping Guide',
      description: 'Insurance coverage',
      linkText: 'Read Article',
      type: 'article'
    },
    {
      title: 'Care Guide',
      description: 'Preserve your collection',
      linkText: 'Read Article',
      type: 'pdf'
    }
  ];

  useEffect(() => {
    if (user) {
      setFormData(prev => ({
        ...prev,
        name: `${user.firstname} ${user.lastname}`,
        email: user.email
      }));
    }
  }, [user]);

  const toggleFaq = (id) => {
    setActiveFaq(activeFaq === id ? null : id);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear validation error when user starts typing
    if (name === 'message') {
      validateMessage(value);
    }
  };

  // Validation function for message field - تم التحديث
  const validateMessage = (message) => {
    const trimmedMessage = message.trim();
    let error = '';

    if (!trimmedMessage) {
      error = 'Message is required';
    } else if (trimmedMessage.length < MESSAGE_MIN_LENGTH) {
      error = `Message must be at least ${MESSAGE_MIN_LENGTH} characters`;
    } else if (trimmedMessage.length > MESSAGE_MAX_LENGTH) {
      error = `Message cannot exceed ${MESSAGE_MAX_LENGTH} characters`;
    }

    setFormErrors(prev => ({
      ...prev,
      message: error
    }));

    return !error; // Returns true if valid
  };

  // Function to count remaining characters - تم التحديث
  const getRemainingCharacters = () => {
    const currentLength = formData.message.trim().length;
    return Math.max(0, MESSAGE_MAX_LENGTH - currentLength);
  };

  const validateForm = () => {
    const errors = {
      message: ''
    };
    
    let isValid = true;
    
    // Validate message
    const isMessageValid = validateMessage(formData.message);
    if (!isMessageValid) {
      isValid = false;
      errors.message = formErrors.message; // Use the error from validateMessage
    }
    
    // Validate subject
    if (!formData.subject) {
      toastError('Please select a subject');
      isValid = false;
    }
    
    setFormErrors(errors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
      
      if (!token) {
        toastError('Please login to submit a support ticket');
        setIsSubmitting(false);
        return;
      }
      
      const ticketData = {
        fullName: formData.name,
        email: formData.email,
        subject: formData.subject,
        orderNumber: formData.orderNumber,
        message: formData.message.trim()
      };
      
      console.log('Sending ticket data:', ticketData);
      
      const response = await fetch(`${API_URL}/api/tickets`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(ticketData)
      });
      
      const result = await response.json();
      
      if (response.ok) {
        // عرض رسالة النجاح من الباك إند
        toastSuccess(result.message || 'Ticket created successfully');
        
        setShowSuccessModal(true);
        setFormData(prev => ({
          ...prev,
          subject: '',
          orderNumber: '',
          message: ''
        }));
        setFormErrors(prev => ({ ...prev, message: '' }));
        
        setTimeout(() => {
          setShowSuccessModal(false);
        }, 5000);
      } else {
        // عرض رسالة الخطأ من الباك إند
        toastError(result.message || 'Failed to submit ticket. Please try again.');
        console.error('Ticket submission error:', result);
      }
    } catch (error) {
      console.error('Network error:', error);
      toastError('Network error. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const scrollToFaqSection = (category) => {
    const element = document.getElementById(`faq-${category}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      
      const firstFaqInSection = faqData.find(faq => faq.category === category);
      if (firstFaqInSection) {
        setTimeout(() => {
          setActiveFaq(firstFaqInSection.id);
        }, 500);
      }
    }
  };

  const faqByCategory = faqData.reduce((acc, faq) => {
    if (!acc[faq.category]) {
      acc[faq.category] = [];
    }
    acc[faq.category].push(faq);
    return acc;
  }, {});

  const categoryLabels = {
    offers: 'Offers & Orders',
    payments: 'Payments & Invoices',
    shipping: 'Shipping & Delivery',
    account: 'Account & Settings'
  };

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans">
      {/* Toaster Component */}
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#fff',
            color: '#000',
            border: '1px solid #e5e5e5',
            padding: '16px',
            borderRadius: '0px',
            fontSize: '14px',
            fontWeight: 'normal',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          },
          success: {
            iconTheme: {
              primary: '#000',
              secondary: '#fff',
            },
          },
          error: {
            style: {
              background: '#fff',
              color: '#dc2626',
            },
            iconTheme: {
              primary: '#dc2626',
              secondary: '#fff',
            },
          },
        }}
      />
      
      <div className="flex flex-col">
        <main className="flex-1">
          <section className="px-4 sm:px-6 lg:px-10 py-8 border-b border-gray-100">
            <div>
              <h1 className="text-sm font-medium tracking-[0.2em] uppercase mb-2">Support</h1>
              <p className="text-sm text-gray-600 font-normal">Get help with your account, orders, and platform questions</p>
            </div>
          </section>

          {/* Quick Help Section - Mobile First */}
          <div className="lg:hidden px-4 sm:px-6 lg:px-8 py-6 border-b border-gray-100">
            <div className="mb-6">
              <h2 className="text-sm font-medium mb-1.5">Quick Help</h2>
              <p className="text-xs text-gray-600 font-normal">Jump to relevant topics</p>
            </div>
            <div className="space-y-3">
              {Object.keys(faqByCategory).map(category => (
                <button
                  key={category}
                  onClick={() => scrollToFaqSection(category)}
                  className="w-full text-left border border-gray-200 bg-white hover:border-gray-300 transition-all hover:shadow-sm"
                >
                  <div className="px-5 py-4">
                    <h3 className="text-xs font-medium mb-1">{categoryLabels[category]}</h3>
                    <p className="text-[11px] text-gray-600 font-normal">
                      {category === 'offers' && 'Questions about offers and order status'}
                      {category === 'payments' && 'Billing and payment questions'}
                      {category === 'shipping' && 'Tracking and delivery times'}
                      {category === 'account' && 'Profile and security settings'}
                    </p>
                  </div>
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-0">
            <div className="lg:col-span-2 border-r border-gray-100">
              <section className="px-4 sm:px-6 lg:px-10 py-8 lg:py-10">
                <div>
                  <div className="mb-8 lg:mb-10">
                    <h2 className="text-base font-medium mb-1.5">Frequently Asked Questions</h2>
                    <p className="text-sm text-gray-600 font-normal">Find answers to common questions</p>
                  </div>

                  {Object.entries(faqByCategory).map(([category, faqs]) => (
                    <div key={category} id={`faq-${category}`} className="mb-10 last:mb-0">
                      <h3 className="text-sm font-medium mb-6 tracking-wide">{categoryLabels[category]}</h3>
                      <div className="border border-gray-100">
                        {faqs.map((faq, index) => (
                          <div 
                            key={faq.id} 
                            className={`border-gray-100 ${index < faqs.length - 1 ? 'border-b' : ''}`}
                          >
                            <button
                              onClick={() => toggleFaq(faq.id)}
                              className="w-full px-4 sm:px-6 lg:px-8 py-4 sm:py-6 flex items-center justify-between hover:bg-gray-50 transition-colors"
                            >
                              <h4 className="text-sm font-normal text-left pr-4">{faq.question}</h4>
                              <i 
                                className={`fa-solid fa-chevron-down text-xs text-gray-600 transition-transform duration-300 ${
                                  activeFaq === faq.id ? 'transform rotate-180' : ''
                                }`}
                              ></i>
                            </button>
                            <div 
                              className={`overflow-hidden transition-all duration-300 ${
                                activeFaq === faq.id ? 'max-h-96' : 'max-h-0'
                              }`}
                            >
                              <div className="px-4 sm:px-6 lg:px-8 pb-4 sm:pb-6">
                                <p className="text-sm text-gray-600 font-normal leading-relaxed">{faq.answer}</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            </div>

            <div className="lg:col-span-1 bg-gray-50">
              <div className="hidden lg:block">
                <section className="px-8 py-10 border-b border-gray-100">
                  <div className="mb-6">
                    <h2 className="text-sm font-medium mb-1.5">Quick Help</h2>
                    <p className="text-xs text-gray-600 font-normal">Jump to relevant topics</p>
                  </div>
                  <div className="space-y-3">
                    {Object.keys(faqByCategory).map(category => (
                      <button
                        key={category}
                        onClick={() => scrollToFaqSection(category)}
                        className="w-full text-left border border-gray-200 bg-white hover:border-gray-300 transition-all hover:shadow-sm"
                      >
                        <div className="px-5 py-4">
                          <h3 className="text-xs font-medium mb-1">{categoryLabels[category]}</h3>
                          <p className="text-[11px] text-gray-600 font-normal">
                            {category === 'offers' && 'Questions about offers and order status'}
                            {category === 'payments' && 'Billing and payment questions'}
                            {category === 'shipping' && 'Tracking and delivery times'}
                            {category === 'account' && 'Profile and security settings'}
                          </p>
                        </div>
                      </button>
                    ))}
                  </div>
                </section>
              </div>

              <section className="px-4 sm:px-6 lg:px-8 py-8 lg:py-10 border-b border-gray-100">
                <div>
                  <div className="mb-6">
                    <h2 className="text-sm font-medium mb-1.5">Contact Support</h2>
                    <p className="text-xs text-gray-600 font-normal">We'll respond within 24 hours</p>
                  </div>
                  <form onSubmit={handleSubmit} className="space-y-5">
                    <div>
                      <label className="block text-[9px] text-gray-400 uppercase tracking-[0.1em] mb-2 font-medium">Full Name</label>
                      <input 
                        type="text" 
                        value={formData.name}
                        disabled
                        className="w-full border border-gray-200 px-3 py-2.5 text-xs focus:outline-none focus:border-gray-300 transition-colors font-light bg-white cursor-not-allowed opacity-70"
                      />
                    </div>
                    <div>
                      <label className="block text-[9px] text-gray-400 uppercase tracking-[0.1em] mb-2 font-medium">Email</label>
                      <input 
                        type="email" 
                        value={formData.email}
                        disabled
                        className="w-full border border-gray-200 px-3 py-2.5 text-xs focus:outline-none focus:border-gray-300 transition-colors font-light bg-white cursor-not-allowed opacity-70"
                      />
                    </div>
                    <div>
                      <label className="block text-[9px] text-gray-400 uppercase tracking-[0.1em] mb-2 font-medium">Subject</label>
                      <select 
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        required
                        className="w-full border border-gray-200 px-3 py-2.5 text-xs focus:outline-none focus:border-gray-300 transition-colors font-light bg-white"
                      >
                        <option value="">Select a topic</option>
                        <option value="offers">Offers & Orders</option>
                        <option value="payments">Payments & Invoices</option>
                        <option value="shipping">Shipping & Delivery</option>
                        <option value="account">Account & Settings</option>
                        <option value="technical">Technical Issue</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-[9px] text-gray-400 uppercase tracking-[0.1em] mb-2 font-medium">Order Number (Optional)</label>
                      <input 
                        type="text" 
                        name="orderNumber"
                        value={formData.orderNumber}
                        onChange={handleInputChange}
                        placeholder="e.g., #AR-2847"
                        className="w-full border border-gray-200 px-3 py-2.5 text-xs focus:outline-none focus:border-gray-300 transition-colors font-light bg-white"
                      />
                    </div>
                    <div>
                      <div className="flex justify-between items-center mb-2">
                        <label className="block text-[9px] text-gray-400 uppercase tracking-[0.1em] font-medium">Message</label>
                        <span className={`text-[9px] font-normal ${
                          getRemainingCharacters() < 50 ? 'text-red-500' : 'text-gray-500'
                        }`}>
                          {getRemainingCharacters()} characters remaining
                        </span>
                      </div>
                      <textarea 
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        rows={5}
                        placeholder={`Describe your issue (minimum ${MESSAGE_MIN_LENGTH} characters, maximum ${MESSAGE_MAX_LENGTH} characters)...`}
                        required
                        className={`w-full border px-3 py-2.5 text-xs focus:outline-none transition-colors font-light resize-none bg-white ${
                          formErrors.message ? 'border-red-300 focus:border-red-400' : 'border-gray-200 focus:border-gray-300'
                        }`}
                      />
                      {formErrors.message && (
                        <p className="text-[10px] text-red-500 mt-1 font-medium">
                          <i className="fa-solid fa-circle-exclamation mr-1"></i>
                          {formErrors.message}
                        </p>
                      )}
                    </div>
                    <div className="pt-2">
                      <button 
                        type="submit"
                        disabled={isSubmitting || formErrors.message}
                        className={`w-full text-xs px-6 py-3 text-white transition-all duration-200 font-normal tracking-wide ${
                          isSubmitting || formErrors.message
                            ? 'bg-gray-400 cursor-not-allowed' 
                            : 'bg-black hover:bg-gray-800'
                        }`}
                      >
                        {isSubmitting ? 'Submitting...' : 'Submit Query'}
                      </button>
                    </div>
                  </form>
                </div>
              </section>

              <section className="px-4 sm:px-6 lg:px-8 py-8 lg:py-10">
                <div>
                  <div className="mb-6">
                    <h2 className="text-sm font-medium mb-1.5">Resources</h2>
                    <p className="text-xs text-gray-600 font-normal">Helpful guides and docs</p>
                  </div>
                  <div className="space-y-3">
                    {resources.map((resource, index) => (
                      <a 
                        key={index}
                        href="#" 
                        className="block border border-gray-200 bg-white hover:border-gray-300 transition-all hover:shadow-sm"
                      >
                        <div className="px-5 py-4">
                          <h3 className="text-xs font-medium mb-1">{resource.title}</h3>
                          <p className="text-[11px] text-gray-600 font-normal mb-2">{resource.description}</p>
                          <span className="text-[10px] text-gray-500 underline">{resource.linkText}</span>
                        </div>
                      </a>
                    ))}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </main>
      </div>

      {showSuccessModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-4">
          <div className="bg-white border border-gray-100 p-6 sm:p-10 max-w-md w-full">
            <div className="text-center">
              <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="fa-solid fa-check text-2xl text-green-600"></i>
              </div>
              <h3 className="text-base font-medium mb-3">Query Submitted Successfully</h3>
              <p className="text-sm text-gray-600 font-normal mb-8">
                Our support team has received your query and will respond within 24 hours. 
              </p>
              <button 
                onClick={() => setShowSuccessModal(false)}
                className="text-xs px-8 py-3 bg-black text-white hover:bg-gray-800 transition-all duration-200 font-normal tracking-wide w-full"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Support2;